module.exports = __webpack_public_path__ + "static/media/Checked-in.d812e53e.svg";